import React, { Fragment } from 'react'
import { Navbar, MulanComponents } from '../../components'

const Mulan = () => {
	return (
		<Fragment>
			<Navbar />
			<MulanComponents />
		</Fragment>
	)
}

export default Mulan
